import React from 'react';
import './Footer.css'; // Import the CSS file for styling

const Footer = () => {
  return (
    <footer className="footer" id='footer1'>
      <div className="footer-container">
        <div className="about">
          <h3 className="footer-heading">About Us</h3>
          <p className="footer-text">
            We provide top-notch waterproofing and construction services to ensure your spaces are safe and durable.
          </p>
        </div>
        <div className="links">
          <h3 className="footer-heading">Quick Links</h3>
          <ul className="footer-list">
            <li className="footer-list-item"><a href="/" className="footer-link">Home</a></li>
            <li className="footer-list-item"><a href="#work1" className="footer-link">Services</a></li>
            
            <li className="footer-list-item"><a href="#service1" className="footer-link">Expertise</a></li>
          </ul>
        </div>
        <div className="contact">
          <h3 className="footer-heading">Contact Us</h3>
          <p className="footer-text">Email: kingkushwaha93@gmail.com</p>
          <p className="footer-text">Phone: (+91) 79992-69342</p>
          <p className="footer-text">Whatsapp: (+91) 79992-69342</p>
        </div>
        {/* <div className="social-media">
          <h3 className="footer-heading">Follow Us</h3>
          <div className="social-icons">
            <a href="#" className="social-icon">Facebook</a>
            <a href="#" className="social-icon">Twitter</a>
            <a href="#" className="social-icon">Instagram</a>
          </div>
        </div> */}
      </div>
      <div className="copyRight">
        <p className="footer-text">© {new Date().getFullYear()} HYDROSEAL. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
